import type { Entity } from '@backstage/catalog-model';
import { PartsCard, isKind, partRefsOf } from './PartsCard';

/** Refs of the Systems a Domain has as parts. */
export const systemRefsOf = (entity: Entity): string[] =>
  partRefsOf(entity, ['system']);

/** Whether the entity is a Domain. */
export const isDomain = (entity: Entity): boolean => isKind(entity, 'domain');

export const DomainSystemsCard = () => (
  <PartsCard
    title="Systems"
    kinds={['system']}
    emptyText="No systems in this domain yet."
  />
);
